module.exports = __webpack_public_path__ + "static/media/tuzoLogoSmall.d0620a27.png";